import React from "react";
import { get } from "lodash";
import Divider from "material-ui/Divider";
import { Flex, Box, Text, Image } from "rebass";
const List = (props) => {
  const { values, isDesktop } = props;
  const header = get(values, "header", "");
  const aligHeader = get(values, "alignHeader", "center");
  const list = get(values, "list", []);
  const columnDesktop = isDesktop ? get(values, "columnDesktop", 2) : 1;
  const visibleHeader = get(values, "visibleHeader", false);
  return (
    <Box width={[1]}>
      {visibleHeader && (
        <Flex width={[1]} style={{ justifyContent: aligHeader }}>
          <Text
            fontSize={[2, isDesktop ? 3 : 2]}
            p={[2]}
            style={{ color: "#00BFFF" }}
          >
            {header}
          </Text>
        </Flex>
      )}
      {visibleHeader && <Divider />}
      <Box width={[1]}>
        <Flex width={[1]} style={{ display: "flex", flexWrap: "wrap" }}>
          {list &&
            list.length > 0 &&
            list.map((item, index) => {
              const imageUrl = isDesktop
                ? get(item, "imageUrl.url", "") !== ""
                  ? get(item, "imageUrl.url", "")
                  : get(item, "imageUrl.urlMobile", "")
                : get(item, "imageUrl.urlMobile", "") !== ""
                ? get(item, "imageUrl.urlMobile", "")
                : get(item, "imageUrl.url", "");
              const title = get(item, "title", "");
              const discount = get(item, "discount", "");
              const titleDiscount = get(item, "titleDiscount", "");
              return (
                <Box
                  width={[1, 1 / columnDesktop]}
                  key={index}
                  p={[1]}
                  style={{
                    borderBottom: isDesktop
                      ? "0px solid #c4c4c4"
                      : "1px solid #c4c4c4",
                  }}
                >
                  <Flex
                    width={[1]}
                    style={{ border: isDesktop ? "1px solid #c4c4c4" : "0px" }}
                    p={[isDesktop ? 2 : 1]}
                  >
                    <Box width={["80px", "180px"]}>
                      <Image src={imageUrl} />
                    </Box>
                    <Box width={[1]} p={[isDesktop ? 2 : 1]}>
                      <Text fontSize={[2, isDesktop ? 3 : 2]}>{title}</Text>
                      <Flex
                        width={[1]}
                        style={{
                          flex: 1,
                          flexDirection: "row",
                          alignItems: "stretch",
                          display: "flex",
                        }}
                      >
                        <Flex
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Text style={{ color: "#00BFFF" }}>
                            {titleDiscount}
                          </Text>
                        </Flex>
                        <Box
                          p={[1]}
                          m={[1]}
                          style={{
                            backgroundColor: "#FF3B3B",
                            borderRadius: "100%",
                            paddingTop: "13px",
                            paddingBottom: "13px",
                            paddingLeft: "8px",
                            paddingRight: "8px",
                          }}
                        >
                          <Text fontSize={[0]} color={"white"}>
                            {discount}%
                          </Text>
                        </Box>
                      </Flex>
                    </Box>
                  </Flex>
                </Box>
              );
            })}
        </Flex>
      </Box>
    </Box>
  );
};

export default List;



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/dealgroup/List.js